module.exports = __webpack_public_path__ + "static/media/text_container_long.3e8f3fab.png";